import { library, config } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";

import Buefy from "buefy";
import { defineNuxtPlugin } from "#app";

config.autoAddCss = false;

library.add(fas);
library.add(far);

export default defineNuxtPlugin((nuxtApp) => {
  // library.add(fas, far);
  nuxtApp.vueApp.component("vue-fontawesome", FontAwesomeIcon);
  nuxtApp.vueApp.use(Buefy as any, {
    defaultIconComponent: "vue-fontawesome",
    defaultIconPack: "fas"
  });
  nuxtApp.provide("buefy", Buefy);
});
